
window.MTGGoldfish.onDocumentReadyArray = window.MTGGoldfish.onDocumentReadyArray || [];
window.MTGGoldfish.onDocumentReadyArray.push(function() { 
  $("input[type=radio][name=do_not_sell_my_information]").change(function() {
		$.post({
			url: "/account/privacy_settings",
			data: { "do_not_sell_my_information" : this.value },
		}).fail(function() {
      $("#privacy_modal_message").html("<span class='text-danger'>There was an error saving your preferences. Please contact customer support.</span>");
    });
  });
  $('#privacy-modal').on('shown.bs.modal', function () {
    $.get("/account/privacy_settings_initialize").fail(function() {
      $("#privacy_modal_message").html("<span class='text-danger'>There was an error retrieving your preferences. Please contact customer support.</span>");
    });
  })
});
